export default __webpack_public_path__ + "static/media/lock.2e0a454b.svg";